import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
        className="block"
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Marquee({ items, dark = false }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y py-4 ${dark ? "border-vv-ivory/15 bg-vv-black" : "border-vv-black/10"}`}>
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className={`flex items-center gap-8 pr-8 font-display text-lg tracking-[0.3em] uppercase whitespace-nowrap ${dark ? "text-vv-ivory/40" : "text-vv-black/40"}`}>
                {item} <span className="text-vv-champagne text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
